export type SupportedMetricTypes = 'Survival Horizon' | 'Throughput' | 'Cumulative';
export type SupportedMetricTrends = 'Thirty Day' | 'Month Day' | 'Week Day';
export interface HistoricalGraphicalInput {
    type: SupportedMetricTypes; // indicates the metric for which the historical data is generated
    calculation: SupportedMetricTrends; // indicates the trend, month day or week day or last 30 days
    histDate: string;
    aggType?: string;
    aggName?: string;
    amount: number;
    currency: string;
    direction: string;
}

export interface HistoricalOutput {
    xfield: string;
    yfields: string[];
    graphicalOutputData: any[];
}

export class HistoricalData {
    type: HistoricalDataType;
    currency: string;
    date: string;
    m0D: number;
    m1D: number;
    m2D: number;
    m1W: number;
    m2W: number;
    m3W: number;
    m1M: number;
    m2M: number;
    m3M: number;
    m4M: number;
    m5M: number;
    m6M: number;

}

export type HistoricalDataType = 'Cumulative' | 'Buffer' | 'Surplus' | 'Survival Horizon' | string;


export const HISTORICAL_DATA_METRIC_FIELDS = ['m0D', 'm1D', 'm2D', 'm1W', 'm2W', 'm3W', 'm1M', 'm2M', 'm3M', 'm4M', 'm5M', 'm6M'];
